import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react";
import { ButtonProps } from "antd";
import { ShadowButton } from "components/ShadowButton/";
import { useAntTheme } from "hooks/useAntTheme/";

export const ActionButton = ({ children, ...props }: ButtonProps) => {
  const { isMobile } = useAntTheme();
  const defaultHeight = props.style?.height || 66;
  const defaultFontSize = props.style?.fontSize || 22;
  return (
    <ShadowButton
      shape="round"
      size="large"
      {...props}
      style={{
        padding: "9px 60px",
        fontWeight: 300,
        maxHeight: "100%",
        maxWidth: "100%",
        width: 262,
        ...props.style,
        height: isMobile ? 40 : defaultHeight,
        fontSize: isMobile ? 16 : defaultFontSize,
      }}
    >
      {props.iconPosition === "start" && (
        <CaretLeftIcon
          style={{
            position: "absolute",
            left: 20,
            fontSize: 16,
          }}
        />
      )}
      <span>{children}</span>
      {props.iconPosition === "end" && (
        <CaretRightIcon
          style={{
            position: "absolute",
            right: 20,
            fontSize: 16,
          }}
        />
      )}
    </ShadowButton>
  );
};
